import { Box, styled } from '@mui/joy';

import { Color } from 'theme/enums';

import TextLine from './TextLine';

interface IProps {
  texts: string[] | JSX.Element[] | (string | JSX.Element)[];
  color?: Color;
  isSubText?: boolean;
  italic?: boolean;
  bold?: boolean;
  upperCase?: boolean;
  maxRows?: number;
  textEllipsis?: boolean;
  inline?: boolean;
}

interface IWrapper {
  inline?: boolean;
}

const propsToSkip = ['inline'];
const shouldForwardProp = (prop: string) => !propsToSkip.includes(prop);

const Wrapper = styled(Box, { shouldForwardProp })<IWrapper>(({ inline }) => ({
  display: 'flex',
  flexDirection: inline ? 'row' : 'column',
  justifyContent: 'inherit',
  alignItems: 'inherit',
  gap: inline ? '10px' : 0,
}));

const TextLines = ({
  texts,
  color,
  isSubText,
  bold,
  italic,
  upperCase,
  maxRows,
  textEllipsis,
  inline = false,
}: IProps) => {
  if (!texts?.length) {
    return null;
  }

  return (
    <Wrapper inline={inline}>
      {texts &&
        texts.map((text: string | JSX.Element, index: number) => (
          <TextLine
            key={index}
            text={text}
            color={color}
            isSubText={isSubText}
            bold={bold}
            italic={italic}
            upperCase={upperCase}
            maxRows={maxRows}
            textEllipsis={textEllipsis}
          />
        ))}
    </Wrapper>
  );
};

export default TextLines;
